/* eslint-disable complexity */
import {
  BookWidgetAem,
  BookWidgetMeetingEventCodeField
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { DisplayInlineTextTypes } from '../../constants/login-dashboard.constants';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { LoginDashboardFieldsConfig } from '../../models/login-dashboard.interfaces';
import { QueryParams } from '../../models/states/query-params-state.interfaces';

export const prepareMeetingEventCodeField = (
  queryParams: QueryParams | null,
  retrieveSearchData: RetrieveSearchData | null,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  hasDeepLinkingParams: boolean,
  loginDashboardFieldsConfig: LoginDashboardFieldsConfig | null,
  bookWidgetAem: BookWidgetAem | null
): BookWidgetMeetingEventCodeField => {
  if (bookWidgetFieldsMasterConfig.meetingEventCodeField?.hide) {
    return {
      meetingEventCodeValue: '',
      disable: false,
      hide: true,
      disclaimerMessage: ''
    };
  }

  let meetingEventCodeValue = '';
  if (
    !bookWidgetFieldsMasterConfig?.meetingEventCodeField?.disable &&
    queryParams?.meetingEventCode
  ) {
    meetingEventCodeValue = queryParams.meetingEventCode;
  } else if (
    !hasDeepLinkingParams &&
    !bookWidgetFieldsMasterConfig?.meetingEventCodeField?.disable &&
    retrieveSearchData?.meetingEventCode
  ) {
    meetingEventCodeValue = retrieveSearchData.meetingEventCode;
  }

  let disclaimerMessage = '';
  if (
    loginDashboardFieldsConfig?.meetingEventDisclaimerType ===
    DisplayInlineTextTypes.rewards
  ) {
    disclaimerMessage =
      bookWidgetAem?.meetingEventCodeField
        ?.edpMeetingCodeDisclaimerForProgram || '';
  } else if (
    loginDashboardFieldsConfig?.meetingEventDisclaimerType ===
    DisplayInlineTextTypes.noprogram
  ) {
    disclaimerMessage =
      bookWidgetAem?.meetingEventCodeField
        ?.edpMeetingCodeDisclaimerForNoProgram || '';
  } else if (
    loginDashboardFieldsConfig?.meetingEventDisclaimerType ===
    DisplayInlineTextTypes.fare
  ) {
    disclaimerMessage =
      bookWidgetAem?.meetingEventCodeField?.edpMeetingCodeDisclaimerForFare ||
      '';
  } else if (
    loginDashboardFieldsConfig?.meetingEventDisclaimerType ===
    DisplayInlineTextTypes.personal
  ) {
    disclaimerMessage =
      bookWidgetAem?.meetingEventCodeField?.edpMeetingCodeDisclaimer || '';
  }

  return {
    meetingEventCodeValue,
    disable:
      bookWidgetFieldsMasterConfig.meetingEventCodeField?.disable || false,
    hide: bookWidgetFieldsMasterConfig.meetingEventCodeField?.hide || false,
    disclaimerMessage
  };
};
